<script lang="ts">
    import type { MaxSpeedToolManager } from "./MaxSpeedToolManager";
    import {SpeedIcon} from "@anyways-open/common-svgs";

    export let manager: MaxSpeedToolManager;
    let visible = manager.getVisibleStore();
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div on:click={() => $visible = !$visible} class="btn btn-toolbox {$visible ? 'active' : ''}">
    <SpeedIcon class="toolbox-icon"/>
</div>

<style>
    .btn-toolbox {
        fill: #fff;
    }
</style>